export const MOTION_DURATION_MS = Object.freeze({
  quick: 160,
  standard: 220,
  deliberate: 280,
});

export const MODEL_PREVIEW_DELAY_MS = 400;

export const easeOutCubic = (progress) => 1 - Math.pow(1 - progress, 3);

export const getBrandEntryScaleMultiplier = (progress) => {
  const settleStart = 0.72;
  const startScale = 0.84;
  const overshootScale = 1.035;

  if (progress <= settleStart) {
    const growProgress = progress / settleStart;
    const easedGrowProgress = 1 - Math.pow(1 - growProgress, 2);
    return startScale + (overshootScale - startScale) * easedGrowProgress;
  }

  const settleProgress = (progress - settleStart) / (1 - settleStart);
  return overshootScale - (overshootScale - 1) * (
    easeOutCubic(settleProgress)
  );
};

export const getBrandExitScaleMultiplier = (progress) => 1 - progress * 0.25;

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

export const runMotion = ({
  duration = MOTION_DURATION_MS.standard,
  onFrame,
  onComplete,
}) => {
  if (prefersReducedMotion() || typeof requestAnimationFrame !== 'function') {
    onFrame(1);
    onComplete?.();
    return () => {};
  }

  let frameId;
  let startTime;
  let cancelled = false;

  const renderFrame = (time) => {
    if (cancelled) {
      return;
    }

    startTime ??= time;
    const progress = Math.min((time - startTime) / duration, 1);
    onFrame(easeOutCubic(progress), progress);

    if (progress < 1) {
      frameId = requestAnimationFrame(renderFrame);
    } else {
      onComplete?.();
    }
  };

  frameId = requestAnimationFrame(renderFrame);

  return () => {
    cancelled = true;
    cancelAnimationFrame?.(frameId);
  };
};
